import React, { useMemo } from 'react';

import { cn } from '@lyearn/style';
import useNavigation from '@/hooks/useNavigation';
import { SidebarItems, SideBarMode } from '@/modules/corporate/modules/admin/hooks/useSidebar';

import SidebarFlyoutProvider from './FlyoutPanel/context';
import { SidebarDisclosureProvider } from './DisclosureContext';
import Section from './Section';
import { isSidebarItemActive } from './utils';

const SidebarItemsList = ({
  sidebarItems,
  mode,
  collapsed = false,
  className,
}: {
  sidebarItems: SidebarItems;
  mode?: SideBarMode;
  collapsed?: boolean;
  className?: string;
}) => {
  const navigation = useNavigation();

  const activeParentId = useMemo(() => {
    for (const section of sidebarItems) {
      for (const item of section.children) {
        if (item.children?.some((child) => isSidebarItemActive(navigation.asPath, child))) {
          return item.id;
        }
      }
    }

    return null;
  }, [navigation.asPath, sidebarItems]);

  return (
    <SidebarFlyoutProvider>
      <SidebarDisclosureProvider activeParentId={activeParentId}>
        <div className={cn('flex w-full flex-col gap-20', className)}>
          {sidebarItems.map((section) => (
            <Section key={section.id} collapsed={collapsed} mode={mode} section={section} />
          ))}
        </div>
      </SidebarDisclosureProvider>
    </SidebarFlyoutProvider>
  );
};

export default React.memo(SidebarItemsList);
